<div class="batch-dialog-container">
    <!-- <h3 mat-dialog-title class="dialog-title">Batch Configuration</h3> -->

    <div mat-dialog-content class="dialog-content">
        <div class="summary-info">
            <div class="info-item">
                <span class="info-label">Total Batches:</span>
                <span class="info-value">{{ batchArray.length }}</span>
            </div>
            <div class="info-divider">|</div>
            <div class="info-item">
                <span class="info-label">Assigned Batches:</span>
                <span class="info-value">{{ getAssignCount() }}</span>
            </div>
            <div class="info-divider">|</div>
            <div class="info-item">
                <span class="info-label">Total Students:</span>
                <span class="info-value">{{ totalStudents }}</span>
            </div>
        </div>

        <div class="table-container">
            <table class="batch-table">
                <thead>
                    <tr>
                        <!-- <th class="col-assign">Assign</th> -->
                        <th class="col-batch">Batch No.</th>
                        <th class="col-name">Batch Name / Code <span class="required-star">*</span></th>
                        <th class="col-students">Student Count</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let b of batchArray; let i = index" [class.row-inactive]="!b.assigned">
                        <!-- <td class="col-assign">
                          <mat-checkbox [(ngModel)]="b.assigned" (change)="onCheckboxChange()" color="primary">
                          </mat-checkbox>
                        </td> -->
                        <td class="col-batch">
                            <span class="batch-number">{{ b.batchNo }}</span>
                        </td>
                        <td class="col-name">
                            <mat-form-field appearance="outline" class="full-width">
                                <input matInput type="text" [(ngModel)]="b.batchName" [disabled]="!b.assigned"
                                    [required]="b.assigned" placeholder="Enter batch name or code">
                                <mat-error *ngIf="b.assigned && (!b.batchName || b.batchName.trim().length === 0)">
                                    Required
                                </mat-error>
                                <mat-error
                                    *ngIf="b.assigned && b.batchName && b.batchName.trim().length > 0 && isDuplicateName(i)">
                                    Duplicate name
                                </mat-error>
                            </mat-form-field>
                        </td>
                        <td class="col-students">
                            <mat-form-field appearance="outline" class="full-width">
                                <input matInput type="text" [value]="b.studCnt" readonly disabled>
                            </mat-form-field>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="!isValid()" class="validation-message">
            <mat-icon class="warning-icon">warning</mat-icon>
            <span *ngIf="hasDuplicateNames()">
                Duplicate batch names detected. Each batch must have a unique name.
            </span>
            <span *ngIf="!hasDuplicateNames()">
                Please provide batch names for all assigned batches
            </span>
        </div>
    </div>

    <div mat-dialog-actions class="dialog-actions">
        <button mat-button class="cancel-btn" (click)="close()">Cancel</button>
        <button mat-raised-button color="primary" class="save-btn" [disabled]="!isValid()" (click)="save()">
            Save Changes
        </button>
    </div>
</div>